import { getTokenJwt } from './../../../services/functions';
import refreshToken from '../refreshToken';
import jwt from 'jsonwebtoken';

export const getTimeStamp = async () => {
  const token = await getTokenJwt(true);
  const decodeToken: any = jwt.decode(token);
  const timeStampDate = new Date(decodeToken?.exp * 1000);
  const timeStampMinutes = timeStampDate.getMinutes() - 1;
  const timeStampWithAmountMinutes = timeStampDate.setMinutes(timeStampMinutes);
  const currentTime = Date.now();
  if (timeStampWithAmountMinutes <= currentTime) {
    await refreshToken();
  } else {
    setTimeout(() => {
      getTimeStamp();
    }, 5000);
  }
};
